<template>
  <AppHeader>Dealer Transactions</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex">
      <div>
        <p class="text-4xl"><small class="text-lg">₹</small>{{ $store.state.user.cash_balance }} <i class="text-lg ion-ios-wallet"></i></p>
        <p class="text-lg text-gray-600">Cash Balance</p>
      </div>
    </div>

    <div v-if="enable_razorpay" class="mt-6">
      <p class="text-xl text-gray-600">Recharge <small>via Razorpay</small></p>
      <div class="flex justify-between py-1 mt-2 bg-white shadow rounded-2xl">
        <p class="mx-4 text-3xl text-gray-500">₹</p>
        <input v-model="form.amount" class="w-full placeholder-gray-700 focus:outline-none" type="number" placeholder="Amount">
        <button @click="preparePaymentRazorpay()" class="px-4 ml-2 -my-1 text-gray-900 rounded-r-lg bg-slate-300 h-100">PAY</button>
      </div>
    </div>

    <div class="flex flex-col mt-6 bg-white shadow rounded-2xl divide-y-2 divide-slate-100">

      <div v-for="tnx in filteredData" :key="tnx.id" class="px-3 py-1 cursor-pointer">
        <div class="flex items-center gap-x-2">
          <p class="text-2xl"><small class="text-base">₹</small>{{ tnx.amount }}</p>
          <p :class="{'bg-red-200': tnx.type == 'debit', 'bg-green-200': tnx.type == 'credit'}" class="inline-block px-1 py-1 text-xs leading-none text-gray-600 uppercase rounded-sm font-catamaran"><small>{{ tnx.type }}</small></p>
        </div>
        <p class="my-1 text-base">{{ tnx.purpose }}</p>
        <div class="flex justify-between">
          <p class="text-gray-500">{{ toDate(tnx.created_at, true) }}</p>
          <p class="text-sm leading-tight text-gray-500">#{{ tnx.id }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'Transactions',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      q: null,
      sort: 'id',
      order: 'desc',
      form: { amount: 10000 },
      enable_razorpay: false,
      enable_upi: false,
      razorpay_minimum_payment: 10000,
      upi_minimum_payment: 500,
      transactions: [],
      filteredData: [],
    }
  },

  watch: {
    q(val) {
      if (!val || val == null || val.length == 0) this.filteredData = this.transactions;
      this.filteredData = this.transactions.filter((item) => JSON.stringify(item).toLowerCase().includes(val.toLowerCase()));
    },
  },

  methods: {
    sortList() {
      this.filteredData.sort((a, b) => (a[this.sort] == b[this.sort] ? 0 : a[this.sort] < b[this.sort] ? -1 : 1) * (this.order == 'desc' ? -1 : 1));
    },

    getTransactions() {
      this.state = 'loading';

      this.request('GET', 'transactions', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.enable_razorpay = resp.data.enable_razorpay;
          this.enable_upi = resp.data.enable_upi;
          this.form.amount = resp.data.razorpay_minimum_payment;
          this.razorpay_minimum_payment = resp.data.razorpay_minimum_payment;
          this.upi_minimum_payment = resp.data.upi_minimum_payment;

          this.transactions = resp.data.transactions;
          this.filteredData = resp.data.transactions;
        } else {
          alert(resp.message ? resp.message : 'Unable to fetch details, please try again.');
        }
      });
    },

    preparePaymentRazorpay() {
      if (this.form.amount < this.paymentMinimumAmount) {
        alert('Amount should be more than Minimum Amount');
        return;
      }

      this.state = 'loading';

      this.request('POST', 'transactions/prepare/razorpay', {amount: this.form.amount}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          window.open(resp.data.url, '_system');
        } else {
          alert(resp.message ? resp.message : 'Please try again later.')
        }
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getTransactions();
  }
}
</script>
